import type { FindReplaceRule, IVariable } from '@carboncopyco/types';
import React from 'react';

export interface FindAndReplaceManagerContextProps {
  rules: FindReplaceRule[];
  variables: IVariable[];
  createRule: (rule: Omit<FindReplaceRule, 'ruleId'>) => Promise<unknown>;
  editRule: (rule: FindReplaceRule) => Promise<unknown>;
  deleteRule: (rule: FindReplaceRule) => Promise<unknown>;
  reorderRules: (
    moved: FindReplaceRule,
    after: FindReplaceRule
  ) => Promise<unknown>;
}

export const FindAndReplaceManagerContext =
  React.createContext<FindAndReplaceManagerContextProps>(undefined);
